



// import axios from "axios";
// import API_BASE_URL from "../config/apiConfig";
// import authHeader from "./auth-header";  // Import de votre fichier existant

// const API_URL = `${API_BASE_URL}/auth/`;

// // Fonctions existantes...
// const register = (username, email, password, confirmPassword, acceptTerms, acceptPrivacy) => {
//   return axios.post(API_URL + "signup", {
//     username,
//     email,
//     password,
//     confirmPassword,
//     acceptTerms,
//     acceptPrivacy,
//     idSite: 1
//   });
// };

// const login = (username, password) => {
//   return axios
//     .post(API_URL + "signin", { username, password })
//     .then((response) => {
//       if (response.data.accessToken) {
//         localStorage.setItem("user", JSON.stringify(response.data));
//       }
//       return response.data;
//     });
// };

// const logout = () => {
//   localStorage.removeItem("user");
//   window.location.href = '/login';
// };

// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };

// // FONCTIONS DE PROFIL UTILISANT authHeader()
// const getProfile = async () => {
//   try {
//     const response = await axios.get(API_URL + "profile", {
//       headers: authHeader()
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la récupération du profil:', error);
//     throw error;
//   }
// };

// const updateProfile = async (profileData) => {
//   try {
//     const response = await axios.put(API_URL + "profile", profileData, {
//       headers: authHeader()
//     });
    
//     // Mettre à jour le localStorage
//     const user = getCurrentUser();
//     if (user) {
//       const updatedUser = { ...user, ...response.data };
//       localStorage.setItem("user", JSON.stringify(updatedUser));
//     }
    
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la mise à jour du profil:', error);
//     throw error;
//   }
// };

// const uploadProfileImage = async (imageData) => {
//   try {
//     const response = await axios.post(
//       API_URL + "profile/upload-image", 
//       { imageData },
//       { headers: authHeader() }
//     );
    
//     // Mettre à jour le localStorage
//     const user = getCurrentUser();
//     if (user) {
//       const updatedUser = { 
//         ...user, 
//         profileImage: response.data.imageUrl || response.data.profileImage 
//       };
//       localStorage.setItem("user", JSON.stringify(updatedUser));
//     }
    
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de l\'upload de l\'image:', error);
//     throw error;
//   }
// };

// const deleteProfileImage = async () => {
//   try {
//     const response = await axios.delete(API_URL + "profile/delete-image", {
//       headers: authHeader()
//     });
    
//     // Mettre à jour le localStorage
//     const user = getCurrentUser();
//     if (user) {
//       const updatedUser = { ...user, profileImage: null };
//       localStorage.setItem("user", JSON.stringify(updatedUser));
//     }
    
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la suppression de l\'image:', error);
//     throw error;
//   }
// };

// const changePassword = async (oldPassword, newPassword) => {
//   try {
//     const response = await axios.post(
//       API_URL + "changepassword",
//       {
//         old_password: oldPassword,
//         new_password: newPassword,
//       },
//       { headers: authHeader() }
//     );
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };



// // ============ NOUVELLES FONCTIONS POUR GOOGLE AUTH ============

// const googleLogin = async (googleResponse) => {
//   try {
//     const response = await axios.post(API_URL + "google-signin", {
//       tokenId: googleResponse.tokenId,
//       email: googleResponse.profileObj.email,
//       name: googleResponse.profileObj.name,
//       picture: googleResponse.profileObj.picture,
//       googleId: googleResponse.profileObj.googleId
//     });
    
//     if (response.data.accessToken) {
//       localStorage.setItem("user", JSON.stringify(response.data));
//     }
    
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la connexion Google:', error);
//     throw error;
//   }
// };

// const googleSignup = async (googleResponse) => {
//   try {
//     const response = await axios.post(API_URL + "google-signup", {
//       tokenId: googleResponse.tokenId,
//       email: googleResponse.profileObj.email,
//       name: googleResponse.profileObj.name,
//       picture: googleResponse.profileObj.picture,
//       googleId: googleResponse.profileObj.googleId
//     });
    
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de l\'inscription Google:', error);
//     throw error;
//   }
// };

// // Fonction pour vérifier si un utilisateur Google existe déjà
// const checkGoogleUser = async (email) => {
//   try {
//     const response = await axios.get(API_URL + `check-google-user?email=${email}`);
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la vérification de l\'utilisateur Google:', error);
//     throw error;
//   }
// };


// // ============ 🆕 FONCTIONS MOT DE PASSE OUBLIÉ ============

// /**
//  * Envoie un email de réinitialisation de mot de passe
//  * @param {string} email - L'adresse email de l'utilisateur
//  */
// const forgotPassword = async (email, username) => {
//   try {
//     const response = await axios.post(API_URL + "forgot-password", { email, username });
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la demande de réinitialisation:', error);
//     throw error;
//   }
// };

// /**
//  * Réinitialise le mot de passe avec le token reçu par email
//  * @param {string} token - Le token de réinitialisation
//  * @param {string} email - L'adresse email de l'utilisateur
//  * @param {string} newPassword - Le nouveau mot de passe
//  */
// const resetPassword = async (token, email, newPassword) => {
//   try {
//     const response = await axios.post(API_URL + "reset-password", {
//       token,
//       email,
//       newPassword
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la réinitialisation du mot de passe:', error);
//     throw error;
//   }
// };

// // ✅ CORRECT — syntaxe de module JS
// const updateEmail = async (newEmail, password) => {
//     try {
//         const response = await axios.put(
//             API_URL + "update-email",
//             { newEmail, password },
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la mise à jour de l'email:", error);
//         throw error;
//     }
// };
// export default {
//   register,
//   login,
//   logout,
//   getCurrentUser,
//   getProfile,
//   updateProfile,
//   uploadProfileImage,
//   deleteProfileImage,
//   changePassword,

   
//   // Exports Google
//   googleLogin,
//   googleSignup,
//   checkGoogleUser,

//   // 🆕 Exports mot de passe oublié
//   forgotPassword,
//   resetPassword,

//   updateEmail
// };

import axios from "axios";
import API_BASE_URL from "../config/apiConfig";
import authHeader from "./auth-header";  // Import de votre fichier existant

const API_URL = `${API_BASE_URL}/auth/`;

// ✅ MODIFIÉ : ajout du paramètre fullName (optionnel)
const register = (username, email, password, confirmPassword, acceptTerms, acceptPrivacy, fullName) => {
  const payload = {
    username,
    email,
    password,
    confirmPassword,
    acceptTerms,
    acceptPrivacy,
    idSite: 1
  };

  // ✅ NOUVEAU : n'envoyer fullName que s'il est fourni et non vide
  if (fullName && String(fullName).trim()) {
    payload.fullName = String(fullName).trim();
  }

  return axios.post(API_URL + "signup", payload);
};

const login = (username, password) => {
  return axios
    .post(API_URL + "signin", { username, password })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
  window.location.href = '/login';
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

// FONCTIONS DE PROFIL UTILISANT authHeader()
const getProfile = async () => {
  try {
    const response = await axios.get(API_URL + "profile", {
      headers: authHeader()
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du profil:', error);
    throw error;
  }
};

const updateProfile = async (profileData) => {
  try {
    const response = await axios.put(API_URL + "profile", profileData, {
      headers: authHeader()
    });

    // Mettre à jour le localStorage
    const user = getCurrentUser();
    if (user) {
      const updatedUser = { ...user, ...response.data };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    }

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du profil:', error);
    throw error;
  }
};

const uploadProfileImage = async (imageData) => {
  try {
    const response = await axios.post(
      API_URL + "profile/upload-image",
      { imageData },
      { headers: authHeader() }
    );

    // Mettre à jour le localStorage
    const user = getCurrentUser();
    if (user) {
      const updatedUser = {
        ...user,
        profileImage: response.data.imageUrl || response.data.profileImage
      };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    }

    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'upload de l\'image:', error);
    throw error;
  }
};

const deleteProfileImage = async () => {
  try {
    const response = await axios.delete(API_URL + "profile/delete-image", {
      headers: authHeader()
    });

    // Mettre à jour le localStorage
    const user = getCurrentUser();
    if (user) {
      const updatedUser = { ...user, profileImage: null };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    }

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la suppression de l\'image:', error);
    throw error;
  }
};

const changePassword = async (oldPassword, newPassword) => {
  try {
    const response = await axios.post(
      API_URL + "changepassword",
      {
        old_password: oldPassword,
        new_password: newPassword,
      },
      { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


// ============ FONCTIONS POUR GOOGLE AUTH ============

const googleLogin = async (googleResponse) => {
  try {
    const response = await axios.post(API_URL + "google-signin", {
      tokenId: googleResponse.tokenId,
      email: googleResponse.profileObj.email,
      name: googleResponse.profileObj.name,
      picture: googleResponse.profileObj.picture,
      googleId: googleResponse.profileObj.googleId
    });

    if (response.data.accessToken) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la connexion Google:', error);
    throw error;
  }
};

const googleSignup = async (googleResponse) => {
  try {
    const response = await axios.post(API_URL + "google-signup", {
      tokenId: googleResponse.tokenId,
      email: googleResponse.profileObj.email,
      name: googleResponse.profileObj.name,
      picture: googleResponse.profileObj.picture,
      googleId: googleResponse.profileObj.googleId
    });

    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'inscription Google:', error);
    throw error;
  }
};

// Fonction pour vérifier si un utilisateur Google existe déjà
const checkGoogleUser = async (email) => {
  try {
    const response = await axios.get(API_URL + `check-google-user?email=${email}`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la vérification de l\'utilisateur Google:', error);
    throw error;
  }
};


// ============ FONCTIONS MOT DE PASSE OUBLIÉ ============

const forgotPassword = async (email, username) => {
  try {
    const response = await axios.post(API_URL + "forgot-password", { email, username });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la demande de réinitialisation:', error);
    throw error;
  }
};

const resetPassword = async (token, email, newPassword) => {
  try {
    const response = await axios.post(API_URL + "reset-password", {
      token,
      email,
      newPassword
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la réinitialisation du mot de passe:', error);
    throw error;
  }
};

const updateEmail = async (newEmail, password) => {
  try {
    const response = await axios.put(
      API_URL + "update-email",
      { newEmail, password },
      { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'email:", error);
    throw error;
  }
};

export default {
  register,
  login,
  logout,
  getCurrentUser,
  getProfile,
  updateProfile,
  uploadProfileImage,
  deleteProfileImage,
  changePassword,

  // Exports Google
  googleLogin,
  googleSignup,
  checkGoogleUser,

  // Exports mot de passe oublié
  forgotPassword,
  resetPassword,

  updateEmail
};